import React from "react";
import { Dialog, DialogContent, IconButton, Grow } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion"; // ← motion追加！
import waraeru from "../data/png/waraeru.png";
import WaraeruTalk from "./WaraeruTalk";

// ふわ〜っと登場するGrow + 1.5秒
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow in timeout={1500} ref={ref} {...props} />;
});

const WaraeruDialog = ({ open, onClose }) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <DialogContent
        className="fade-background"
        style={{
          position: "relative",
          height: "100vh",
          paddingTop: "64px",
          textAlign: "center",
        }}
      >
        {/* ✕ボタン */}
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>

        {/* わらえる君との対話エリア */}
        <WaraeruTalk />
      </DialogContent>
    </Dialog>
  );
};

export default WaraeruDialog;
